<div class="flex justify-center items-center h-full">
    <div class="text-neutral-800 dark:text-neutral-100" style="min-width: 500px;">
      <!---Modal header-->
      <div class="headerModal" style="padding: 1.5rem 2.5rem;">
        <span class="font-bold text-24px">Solicitud de alta en el Padrón de Instaladores</span>
      </div>

      <!---Modal Body-->
      <div class="bodyModal" style="color: #242A35; padding: 2.5rem 7.5rem;">
        <div *ngIf="!hiddenForm" class="flex flex-col gap-6">
          <span class="text-14px font-semibold">Datos de la empresa instaladora</span>
          <form
            style="min-width: 10.625rem;"
            [formGroup]="installersForm"
          >
            <div>
              <mat-form-field appearance="outline" class="w-full">
                <mat-label>Nombre comercial</mat-label>
                <input matInput type="text" id="company_name" [formControlName]="'company_name'">
              </mat-form-field>
            </div>
            <div>
              <mat-form-field appearance="outline" class="w-full">
                <mat-label>Razón social</mat-label>
                <input matInput type="text" id="legal_name" [formControlName]="'legal_name'">
              </mat-form-field>
            </div>
            <div>
              <mat-form-field appearance="outline" class="w-full">
                <mat-label>Dirección</mat-label>
                <input matInput type="text" id="address" [formControlName]="'address'">
              </mat-form-field>
            </div>
            <div>
              <mat-form-field appearance="outline" class="w-full">
                <mat-label>Teléfono</mat-label>
                <input matInput type="text" id="phone_number" [formControlName]="'phone_number'" maxlength="20" (keypress)="phoneFormat($event)">
              </mat-form-field>
            </div>
            <div>
              <mat-form-field appearance="outline" class="w-full">
                <mat-label>Correo</mat-label>
                <input matInput type="text" id="email" [formControlName]="'email'">
              </mat-form-field>
            </div>

            <div class="flex justify-end">
              <div class="flex gap-2.5">
                <button
                    (click)="close()"
                    class="border rounded-md py-3 px-8 bold"
                    style="background-color: #FFFFFF; border-color: #94D357; border-radius: 0.5rem; font-size: 1rem; cursor: pointer;"
                >
                  Cerrar
                </button>
                <button
                  (click)="submitInstallerForm()"
                  class="border rounded-md py-3 px-8 font-bold"
                  style="background-color: #94D357; border-bottom: #94D357; border-radius: 0.5rem; font-size: 1rem; cursor: pointer;"
                >
                  {{ loading ? ('loadingMessage' | translate) : 'Enviar formulario' }}
                </button>
              </div>
            </div>
          </form>
        </div>

        <div *ngIf="hiddenForm" class="flex flex-col text-center justify-between" style="min-height: 30rem;">
          <div class="flex flex-col gap-6 pt-7">
            <mat-icon class="material-symbols-rounded text-80 mx-auto" style="width: 80px; height: 80px; color: #4AA800;">check_circle</mat-icon>
            <div class="flex flex-col text-24px gap-6">
                <span>El formulario ha sido enviado con éxito.</span>
            </div>
          </div>

          <div class="flex justify-end">
            <button
              (click)="close()"
              class="border rounded-md py-3 px-8 bold"
              style="background-color: #FFFFFF; border-color: #94D357; border-radius: 0.5rem; font-size: 1rem; cursor: pointer;"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
</div>
